<script>
export default {
    name: "ModalGenerateRtb30",
    data() {
        return {
            loading: false,
            visible: false,
            agents: [],
            offices: [],
            form: {
                agent_id: '',
                landlord_id: '',
                tenancy_act: '',
                service_details: [],
                sign_date: '',
            },
            tenancyActs: [
                {
                    id: '1',
                    value: 'This Notice applies to the Manufactured Home Park Tenancy Act, Section 39',
                },
                {
                    id: '2',
                    value: 'This Notice applies to the Residential Tenancy Act, Section 46',
                }
            ],
            serviceDetails: [
                {
                    id: '1',
                    value: 'In person to the tenant or agent of the tenant or an adult (over 19) who appears to live with the tenant',
                },
                {
                    id: '2',
                    value: 'Sending a copy by registered mail to the address at which the person resides',
                },
                {
                    id: '3',
                    value: 'Leaving a copy in a mailbox or mail slot at the address where the person resides',
                },
                {
                    id: '4',
                    value: 'Attaching a copy to the door or other conspicuous place where the tenant resides',
                },
                {
                    id: '5',
                    value: 'Faxes it to a fax number you have provided as an address for service',
                },
                {
                    id: '6',
                    value: 'Email to an email address you have provided as an address for service',
                },
                {
                    id: '7',
                    value: 'As ordered by the Director of the Residential Tenancy Branch (attach copy of Substituted Service Order)',
                },
            ],
            callback: null
        }
    },
    methods: {
        open(callback) {
            this.visible = true;
            this.callback = callback;
        },
        close() {
            this.visible = false;
        },
        submit() {
            this.close();
            if (this.callback) this.callback(this.form);
        },
    },
    mounted() {
        this.loading = true;
        Promise.all([
            this.$get('/users'),
            this.$get('/sterling/offices'),
        ]).then(([agentRes, officeRes]) => {
            this.agents = agentRes.data.items;
            this.offices = officeRes.data.items;
        }).finally(() => {
            this.loading = false;
        });
    }
}
</script>

<template>
    <el-dialog title="Generate Report For 10 Day Notice to End Tenancy For Unpaid Rent or Utilities"
               closeable
               :visible.sync="visible"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               :modal-append-to-body="true"
               :append-to-body="true"
               @close="close"
    >
        <div style="padding-right: 30px">
            <el-form :v-loading="loading" size="medium" label-width="140px" style="max-width: 100%;">
                <el-form-item label="Agent">
                    <el-select v-model="form.agent_id" placeholder="Select Agent">
                        <el-option v-for="agent in agents" :key="agent.id" :label="agent.nickname"
                                   :value="agent.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Landlord">
                    <el-select class="w500" v-model="form.landlord_id" placeholder="Select Landlord">
                        <el-option v-for="office in offices" :key="office.id" :label="office.name"
                                   :value="office.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Tenancy Act">
                    <el-select class="w500" v-model="form.tenancy_act" placeholder="Select Tenancy Act">
                        <el-option v-for="act in tenancyActs" :key="act.id" :label="act.value"
                                   :value="act.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Service Details">
                    <el-checkbox-group v-model="form.service_details">
                        <el-checkbox v-for="detail in serviceDetails" :key="detail.id" :label="detail.id">
                            {{ detail.value }}
                        </el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item label="Sign Date">
                    <el-date-picker
                        v-model="form.sign_date"
                        type="date"
                        placeholder="Select date"
                        format="dd/MM/yyyy"
                        value-format="dd/MM/yyyy"
                        style="width: 100%;"
                    />
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submit">Confirm</el-button>
                </el-form-item>
            </el-form>
        </div>
    </el-dialog>
</template>

<style scoped>

</style>